// extracted by mini-css-extract-plugin
module.exports = {"closing":"CSClosingCarousel_closing__2A0BD","content":"CSClosingCarousel_content__uHTup","div":"CSClosingCarousel_div__1bTbd"};